import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/members/groups-committees/$groupUuid/"
)({
  component: GroupIndexRedirect,
})

function GroupIndexRedirect() {
  const { groupUuid } = Route.useParams()

  return (
    <Navigate
      to="/members/groups-committees/$groupUuid/$tabKey"
      params={{ groupUuid, tabKey: "overview" }}
    />
  )
}
